<template>
  <TheNavigation />
  <div class="container">
    <router-view v-slot="{ Component }">
      <transition
        :name="$route.meta.noTransition ? 'none' : 'fade'"
        mode="out-in"
      >
        <component :is="Component" :key="$route.path" />
      </transition>
    </router-view>
  </div>
</template>
<script>
import TheNavigation from "@/components/TheNavigation";
export default {
  components: { TheNavigation },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
